import React, {useState, useEffect} from 'react';
import { useSelector } from 'react-redux';

import { View, Text } from 'react-native';
import styled from 'styled-components/native';
import {
  WorkoutContainerText,
  WorkoutTextSubHeader
} from '../styles/common-styles.js';

function ActivityButton({name, id, thumbnail, text, shortcode, current_workout, navigation, isWorkout, userType, hasScoring, userId}) {

  // if(userType !== 'Administrator' && hasScoring !== "1"){
  //   return;
  // }

  const [workout_Id, setWorkout_Id] = useState(0);
  const { current_workout_activity} = useSelector((state) => state.cbcWorkout);


  useEffect(() => {
    if(current_workout_activity.type == "free_choice" || current_workout_activity.name == "Free Choice"){
      ////console.log('free_choice game');
      ////console.log(current_workout , current_workout.id);
      setWorkout_Id(current_workout.id)
    }
  }, [current_workout_activity]);


  function activityNavigator(){
    if(hasScoring == 1){
      ////console.log('has scoring' , hasScoring);
      navigation.navigate('gameview', { 
        current_workout_activity: {
          id: id, 
          name: name, 
          shortcode: shortcode,
          type: current_workout_activity.type,
          current_workout_name: current_workout_activity.name
        }, 
        current_workout: current_workout,
        isWorkout: isWorkout
      })
    } else {
      ////console.log('!has scoring' , hasScoring);
      navigation.navigate('activitycontainer', { 
        activityName: shortcode, 
        activityId: id, 
        userId: userId, 
        gameType: 0, 
        workoutId: workout_Id
      })
    }
  }
  

  return (
    <ActivityButtonParent onPress={() => {
          activityNavigator()
      }}>
        <ActivityButtonHeaderImage
            source={{
                uri: `${thumbnail}`,
            }}
            resizeMode='contain'
        />
        <ActivityButtonTextContainer>
            <WorkoutTextSubHeader>
                {name}
            </WorkoutTextSubHeader>
            <ActivityButtonText>
                {text}
            </ActivityButtonText>

        </ActivityButtonTextContainer>

    </ActivityButtonParent>
  );
}

export const ActivityButtonParent = styled.TouchableOpacity`
    height:170px;
    width:170px;
    border:0.5px solid lightgray;
    border-radius:15px;
    overflow:hidden;
    margin-right:10px;
    margin-bottom:10px;
`;

export const ActivityButtonHeaderImage = styled.Image`
    width:100%;
    height:50%;
    border-top-left-radius:15px;
    border-top-right-radius:15px;
    overflow:hidden;
`

export const ActivityButtonText = styled(WorkoutContainerText)`
    font-size:12px;
    margin-top:2.5px;
`

export const ActivityButtonTextContainer = styled.View`
    width:100%;
    height:50%;
    padding:10px;
    background:white;
    overflow:hidden;
    border-bottom-right-radius:15px;
    border-bottom-left-radius:15px;
`

export default ActivityButton;
